.spork-datepicker-wrapper.react-datepicker-wrapper,
.spork-datepicker-wrapper .react-datepicker__input-container {
  display: inline-flex;
  width: auto;
  max-width: max-content;
  flex: 0 0 auto;
  vertical-align: middle;
}

.spork-datepicker-popper {
  z-index: 50;
}

.spork-datepicker {
  border: 1px solid hsl(var(--border));
  border-radius: calc(var(--radius) - 2px);
  background-color: hsl(var(--card));
  color: hsl(var(--foreground));
  font-family: Inter, system-ui, sans-serif;
  box-shadow:
    0 4px 6px -1px rgb(0 0 0 / 0.08),
    0 2px 4px -2px rgb(0 0 0 / 0.08);
}

.spork-datepicker .react-datepicker__header {
  background-color: hsl(var(--card));
  border-bottom: 1px solid hsl(var(--border));
}

.spork-datepicker .react-datepicker__current-month,
.spork-datepicker .react-datepicker__day-name,
.spork-datepicker .react-datepicker-time__header {
  color: hsl(var(--foreground));
}

.spork-datepicker .react-datepicker__day {
  color: hsl(var(--foreground));
  border-radius: calc(var(--radius) - 4px);
}

.spork-datepicker .react-datepicker__day:hover {
  background-color: hsl(var(--accent));
  color: hsl(var(--accent-foreground));
}

.spork-datepicker .react-datepicker__day--selected,
.spork-datepicker .react-datepicker__day--keyboard-selected {
  background-color: hsl(var(--primary));
  color: hsl(var(--primary-foreground));
}

.spork-datepicker .react-datepicker__day--selected:hover,
.spork-datepicker .react-datepicker__day--keyboard-selected:hover {
  background-color: hsl(var(--primary-hover));
}

.spork-datepicker .react-datepicker__day--disabled {
  color: hsl(var(--muted-foreground));
  opacity: 0.5;
}

.spork-datepicker .react-datepicker__navigation-icon::before {
  border-color: hsl(var(--muted-foreground));
}

.spork-datepicker .react-datepicker__triangle {
  display: none;
}

.react-datepicker__portal {
  position: fixed;
  inset: 0;
  z-index: 2147483647;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100vw;
  height: 100vh;
  padding: 1rem;
  background-color: rgb(0 0 0 / 0.4);
}

.react-datepicker__portal .spork-datepicker {
  position: relative;
  z-index: 1;
  border-radius: var(--radius);
}

.spork-datepicker .react-datepicker__time-container,
.spork-datepicker .react-datepicker__time,
.spork-datepicker .react-datepicker__time-box {
  background-color: hsl(var(--card));
  border-color: hsl(var(--border));
}

.spork-datepicker .react-datepicker__time-list-item {
  color: hsl(var(--foreground));
}

.spork-datepicker .react-datepicker__time-list-item:hover {
  background-color: hsl(var(--accent));
  color: hsl(var(--accent-foreground));
}

.spork-datepicker .react-datepicker__time-list-item--selected {
  background-color: hsl(var(--primary));
  color: hsl(var(--primary-foreground));
}
